
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg","data-token-name":"pen-circle"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.47 12.587L6 12.941l.353-2.471 5.031-5.031a1.497 1.497 0 012.117 2.117l-5.03 5.031z","stroke":"currentColor","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M.625 10a9.375 9.375 0 1018.75 0 9.375 9.375 0 00-18.75 0v0z","stroke":"currentColor","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M6 15.25h5.953c.214 0 .427-.035.63-.105v0c.274-.095.524-.252.73-.457L14 14","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    